import { useEffect, useState } from 'react';
import { css } from '@emotion/react';
import { BNPLApi } from '@frontend/api-buy-now-pay-later';
import { Divider } from '@frontend/divider';
import { theme } from '@frontend/theme';
import { BuyNowPayLaterInfo } from './atoms/info';
import { BuyNowPayLaterSignup } from './atoms/signup';
import { BuyNowPayLaterStatus } from './atoms/status';
import { BuyNowPayLaterPageWrapper } from './atoms/wrapper';

type MerchantStatusObjType = {
  status: string | null;
  url: string | URL | undefined;
};

type BuyNowPayLaterProps = {
  locationId: string | undefined;
};

export const BuyNowPayLater = ({ locationId }: BuyNowPayLaterProps) => {
  const [merchantObj, setMerchantObj] = useState<MerchantStatusObjType>({
    status: 'LOADING',
    url: undefined,
  });
  const [refetchStatus, setRefetchStatus] = useState(0);

  const getMerchantStatus = async () => {
    try {
      const { status, url } = await BNPLApi.buyNowPayLater.status(locationId ?? '');
      setMerchantObj({ status, url });
    } catch (err: any) {
      setMerchantObj({ status: 'NOT_CREATED', url: undefined });
    }
  };

  const updateMerchantStatus = () => setRefetchStatus(Math.random());

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    if (
      merchantObj.status !== 'LOADING' &&
      merchantObj.status !== 'NOT_CREATED' &&
      merchantObj.status !== 'ACTIVATED' &&
      merchantObj.status !== 'DECLINED' &&
      !interval
    ) {
      interval = setInterval(updateMerchantStatus, 30000);
    }

    return () => clearInterval(interval);
  }, [merchantObj.status]);

  useEffect(() => {
    getMerchantStatus();
  }, [refetchStatus]);

  return (
    <BuyNowPayLaterPageWrapper merchantStatus={merchantObj.status} isLoading={merchantObj.status === 'LOADING'}>
      <Divider
        css={css`
          width: 110%;
          margin-left: -${theme.spacing(5)};
        `}
      />
      {merchantObj.status === 'NOT_CREATED' ? (
        <BuyNowPayLaterSignup locationId={locationId} updateStatus={updateMerchantStatus} />
      ) : (
        <BuyNowPayLaterStatus
          locationId={locationId}
          merchantStatus={merchantObj.status}
          merchantUrl={merchantObj.url}
        />
      )}
      {merchantObj.status !== 'ACTIVATED' && <BuyNowPayLaterInfo />}
    </BuyNowPayLaterPageWrapper>
  );
};
